// apps/web/src/lib/shell/transicao.ts — Fase 17.8, Plano 22 (D-19; UI-SPEC U-28).
// Modo da transição de página: 'completa' = opacity + translateY(4px -> 0); 'so-opacidade' nas rotas com arrastar e medir
// (Kanban com dnd-kit e Gantt com dhtmlx-gantt), onde um ancestral com transform deslocaria as medições (RESEARCH, Armadilha 16).
export type ModoTransicao = 'completa' | 'so-opacidade';

const ROTAS_SO_OPACIDADE: readonly string[] = ['/planejamento/kanban', '/planejamento/gantt'];

export function modoTransicao(pathname: string): ModoTransicao {
  const caminho = pathname.split(/[?#]/, 1)[0] ?? '';
  return ROTAS_SO_OPACIDADE.some((rota) => caminho === rota || caminho.startsWith(`${rota}/`)) ? 'so-opacidade' : 'completa';
}
